<template>
  <IncidentAffectedUsers />
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

import IncidentAffectedUsers from "@/modules/PhishTitan/views/Common/Incidents/IncidentSummary/AffectedUsers/index.vue";
import { usePageMetaStore } from "@/store/pageMeta.store";

const pageMetaStore = usePageMetaStore();
const { t } = useI18n();

pageMetaStore.setPageTitle({
  title: t("incident-summary"),
});
</script>
